<span [ngSwitch]="field.widget" [attr.data-schema-path]="field.path" [attr.data-widget-type]="field.widget">
  <xvi-label
    *ngSwitchCase="'label'"
    [control]="control"
    [disabled]="field.disabledObs | async"
    [title]="field.title"
    [titleObs]="field.titleObs"
    [itemClass]="field.widgetData?.itemClass"
    [widgetData]="field.widgetData"
    [textColor]="field.widgetData?.textColor"
    [backgroundColor]="field.widgetData?.backgroundColor"
  ></xvi-label>
  <xvi-input-currency
    *ngSwitchCase="'input-currency'"
    [required]="field.required"
    [disabled]="field.disabledObs | async"
    [class]="'form-control'"
    [label]="field.title"
    [min]="field.minimum"
    [max]="field.maximum"
    [control]="control"
  ></xvi-input-currency>
</span>
